import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/gi-logo-mobile.png'
import _imports_1 from '../../assets/landing/copy-Icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-6a6ac050"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"padding":"14rem"},
  class: "red-background"
}
const _hoisted_2 = { class: "p-d-flex p-justify-around p-pt-6 red-background" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo",
  class: "logo-mobile"
}, null, -1))
const _hoisted_4 = { class: "p-d-flex p-flex-column red-background" }
const _hoisted_5 = {
  class: "mobile-buttons",
  href: "mailto: contact@gameinfluencer.com"
}
const _hoisted_6 = { class: "p-d-flex p-jc-center footer-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!

  return (_openBlock(), _createBlock(_component_Sidebar, {
    visible: _ctx.op,
    "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.op) = $event)),
    position: "top",
    style: {"height":"auto","padding":"0px"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", {
            class: "material-icons close-button-mobile",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, "close")
        ]),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("button", {
            class: "login-button-mobile",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'login' })))
          }, "Login / Register"),
          (_ctx.view === 'creator')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "mobile-buttons",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.discord && _ctx.discord(...args)))
              }, "Discord"))
            : _createCommentVNode("", true),
          _createElementVNode("a", _hoisted_5, [
            _createTextVNode(" Contact "),
            _createElementVNode("img", {
              src: _imports_1,
              class: "copy-image",
              draggable: "false",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copyToClipboard('contact@gameinfluencer.com')))
            })
          ]),
          (_ctx.view === 'creator')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ name: 'brand-view' }))),
                class: "switch-mobile"
              }, " Switch to brand view "))
            : _createCommentVNode("", true),
          (_ctx.view === 'brand')
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({ name: 'influencer-view' }))),
                class: "switch-mobile"
              }, " Switch to influencer view "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push({ name: 'terms-of-use' }))),
              class: "p-mt-4"
            }, "Terms of Use"),
            _createElementVNode("div", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push({ name: 'legacy-of-notice' }))),
              class: "p-mt-4"
            }, " Legal Notice"),
            _createElementVNode("div", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push({ name: 'privace-policy' }))),
              class: "p-mt-4"
            }, "Privacy Policy")
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}